import { IeLynxObject } from "../../common/models/eLynxObject";
import { getObjectTypeName } from "../../common/utilities/GetObjectTypeName";
import { ISpotTagPollingScheduleModel, ITagPollingScheduleUpdateModel } from "../properties-data-service/Models";
import restService from "../rest-service/RestService";
import { IPollingScheduleDataModel, ITagPollingScheduleData } from "./Models";



const PollingFrequencyDataService = {

    getPollingFrequencyData: async(contextGroupID: number, signal?: AbortSignal): Promise<IPollingScheduleDataModel> => {

        const path = `groups/${contextGroupID}/pollingschedules`;

        const response = await restService.get<IPollingScheduleDataModel>(path, signal);
        return response.data;

    },
    savePollingFrequencyData: async(contextGroupID: number, data: ITagPollingScheduleData[]): Promise<void> => {

        const path = `groups/${contextGroupID}/pollingschedules`;
        await restService.post<ITagPollingScheduleData[], void>(path, data);
    },
    saveObjectPollingFrequencyData: async(contextGroupID: number, 
            eLynxObject: IeLynxObject,
            pollingSchedule: ITagPollingScheduleUpdateModel) : Promise<ISpotTagPollingScheduleModel[]> => {

        const path = `groups/${contextGroupID}/${getObjectTypeName(eLynxObject.objectType, true, true)}/${eLynxObject.id}/tagpollingschedules`;

        const response = await restService.post<ITagPollingScheduleUpdateModel, ISpotTagPollingScheduleModel[]>(path, pollingSchedule);
        return response.data;
    }

    // public savePollingSchedules(groupID: number, eLynxObject: Models.IeLynxObjectModel, pollingSchedule: Models.ITagPollingScheduleUpdateModel): Services.RestPromise<Models.ITagPollingScheduleUpdateModel> {

    //     var objectTypeRoute: string = null;

    //     switch (eLynxObject.objectType) {

    //         case Enums.eLynxObjectTypeEnum.Device:
    //             objectTypeRoute = "devices";
    //             break;

    //         case Enums.eLynxObjectTypeEnum.Tank:
    //             objectTypeRoute = "tanks";
    //             break;

    //         default:
    //             objectTypeRoute = "devices";
    //             break;
    //     }

    //     var path: string = [
    //         "groups",
    //         groupID,
    //         objectTypeRoute,
    //         eLynxObject.id,
    //         "tagpollingschedules"
    //     ].join("/");

        

    //     return this._restService.post(path, pollingSchedule).then((data: Services.IRestResponse<Models.ITagPollingScheduleUpdateModel>) => {
    //         return data.entity;
    //     });
    // };

      
};


// public savePollingScheduleData(groupID: number, pollingSchedules: Array<Models.ITagPollingScheduleData>): Services.RestPromise<any> {
//     let path: string = [
//         "groups",
//         groupID,
//         "pollingschedules"
//     ].join("/");

//     return this._restService.post(path, pollingSchedules).then((data: Services.IRestResponse<any>) => {
//         return data.entity;
//     });
// }

export default PollingFrequencyDataService;

